/**
 * Progressive web app support: install detection, the install nudge policy and the
 * service worker. `bootPwa` is the one call the web entry makes; everything else is for
 * the nudge UI (app/Components/Pwa) and `useDevice().isStandalone`.
 */
import { captureInstallEvents } from './installPrompt';
import { registerServiceWorker } from './registerServiceWorker';

export {
	getInstallMethod,
	type InstallMethod,
	isStandaloneDisplay,
	type NativePromptOutcome,
	promptNativeInstall,
	subscribeToInstallChanges,
	wasInstalledThisSession,
} from './installPrompt';
export {
	type InstallNudgeState,
	markInstalled,
	markNeverShowAgain,
	markNudgeShown,
	offersNeverShowAgain,
	readNudgeState,
	shouldShowInstallNudge,
	writeNudgeState,
} from './installNudgePolicy';

/** Runs before React mounts so an early `beforeinstallprompt` is not missed. */
export function bootPwa(): void {
	captureInstallEvents();
	registerServiceWorker();
}
